import { TimelineBaseRequest } from '@types';
import { createGetEndpoint, getQueryString } from '@sonar-software/sonar-http';

export type GetTimelineSynopsisRequest = TimelineBaseRequest;

export type TimelineSynopsisResponse = {
	additions: number;
	admins: number;
	automations: number;
	deletions: number;
	fields: number;
	modifications: number;
	objects: number;
};

export const getTimelineSynopsis = createGetEndpoint<GetTimelineSynopsisRequest, TimelineSynopsisResponse>(
	(request) => `/api/v3/timelines/synopsis?${getQueryString(request)}`
);
